import { useSWRConfig } from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export interface ResendWebinarAttemptRequest {
  eventId: number;
  contactIds: number[]; // guests to resend to (must be in staging)
}

export interface ResendWebinarAttemptResponse {
  message: string;
}

export function useResendWebinarPromotionMessage() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    request: ResendWebinarAttemptRequest,
  ): Promise<ResendWebinarAttemptResponse> =>
    service
      .post(`/api/webinars/${request.eventId}/resend-promotion-message`)
      .set(headers)
      .send({
        contact_ids: request.contactIds,
      })
      .then(tokenRefreshHandler)
      .then((res: any) => res.body)
      .then((res: any) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate webinar queries to refresh the data
        Array.from(keys)
          .filter((r: any) => r.includes("/api/webinars"))
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .catch(errorHandler);
}

export default useResendWebinarPromotionMessage;
